import axios from 'axios';
import router from '../router/index.js';

import { Message, Loading } from 'element-ui';

const service = axios.create({
  //baseURL: 'http://yapi.repo.kitecloud.cn:8081/mock/44/xzzx', // api 的 base_url
  baseURL: '/forum-pub-api/',
  timeout: 50000, // request timeout
});
let loading; // 定义loading变量

function startLoading() {
  // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    // text: '加载中...',
    background: 'rgba(255, 255, 255, 0.7)',
  });
}

function endLoading() {
  // 使用Element loading-close 方法
  loading.close();
}

// 请求拦截  设置统一header
service.interceptors.request.use(
  (config) => {
    // 加载
    startLoading();
    config.headers.common['app-id'] = 'app-01';
    if (localStorage.eleToken) {
      config.headers.Authorization = localStorage.eleToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截  401 token过期处理
service.interceptors.response.use(
  (res) => {
    endLoading();
    return res;
  },
  (error) => {
    // 错误提醒
    endLoading();
    Message.error(error.res.data.message);
    console.log(error.res.data.message);

    if (error.res.status === 401) {
      alert('登录信息已过期，请重新登录');
      // 清除token
      localStorage.removeItem('eleToken');
      // 页面跳转
      router.push('/');
    }
    return Promise.reject(error);
  },
);

export default service;
